/* HomeRun Prints: make the Section Store cart-drawer checkout button match the
   theme's Add to cart button. The drawer renders inside a shadow DOM, so theme
   CSS cannot reach it; this injects a <style> into that shadow root. */
(() => {
  const CSS = `
    .cart-checkout-link {
      font-family: Poppins, sans-serif !important;
      font-size: 19px !important;
      font-weight: 700 !important;
      letter-spacing: 0.5px !important;
      text-transform: uppercase !important;
      line-height: 1.2 !important;
      padding: 19px 26px !important;
      border-radius: 12px !important;
      box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 12px 0px !important;
      height: auto !important;
      min-height: 0 !important;
    }
  `;
  const inject = (host) => {
    const root = host && host.shadowRoot;
    if (!root || root.querySelector('style[data-hrp-checkout]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-hrp-checkout', '');
    style.textContent = CSS;
    root.appendChild(style);
  };
  const scan = () => document.querySelectorAll('section-store--cart-block').forEach(inject);
  scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
